(function () {
  if (window.__gigaReservationInit) return;
  window.__gigaReservationInit = true;

  const ENDPOINT = 'https://gigahub.ba/shopify/reservation';
  const SUCCESS_CLOSE_MS = 4000;
  const MESSAGES = {
    required: 'Molimo popunite sva obavezna polja.',
    email: 'Unesite ispravnu email adresu.',
    sku: 'Ovaj artikal trenutno nije moguće rezervisati. Kontaktirajte našu podršku.',
    network: 'Došlo je do problema s povezivanjem. Pokušajte ponovo.',
    server: 'Zahtjev trenutno nije moguće poslati. Pokušajte ponovo.',
  };

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function isAcceptablePhone(value) {
    const digits = value.replace(/\D/g, '');
    return digits.length >= 5 && digits.length <= 20;
  }

  onReady(function () {
    const root = document.getElementById('GigaReservationModal');
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const dialog = root.querySelector('[data-reservation-dialog]');
    const formView = root.querySelector('[data-reservation-form-view]');
    const form = root.querySelector('[data-reservation-form]');
    const successView = root.querySelector('[data-reservation-success]');
    const nameInput = root.querySelector('[data-reservation-name]');
    const phoneInput = root.querySelector('[data-reservation-phone]');
    const emailInput = root.querySelector('[data-reservation-email]');
    const errorEl = root.querySelector('#GigaReservationError');
    const submitButton = root.querySelector('[data-reservation-submit]');
    const submitLabel = root.querySelector('[data-reservation-submit-label]');
    const spinner = root.querySelector('[data-reservation-spinner]');
    const productImage = root.querySelector('[data-reservation-product-image]');
    const productTitle = root.querySelector('[data-reservation-product-title]');
    const successTitle = root.querySelector('#GigaReservationSuccessTitle');

    let opener = null;
    let submitting = false;
    let requestToken = 0;
    let closeTimer = null;
    let previousOverflow = '';

    function focusableElements() {
      return Array.from(
        dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return !element.closest('[hidden]');
      });
    }

    function setError(message) {
      if (!message) {
        errorEl.hidden = true;
        errorEl.textContent = '';
        return;
      }
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function setFieldInvalid(input, invalid) {
      if (invalid) {
        input.setAttribute('aria-invalid', 'true');
        input.setAttribute('aria-describedby', 'GigaReservationError');
      } else {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
      }
    }

    function setLoading(isLoading) {
      submitting = isLoading;
      submitButton.disabled = isLoading;
      submitButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      spinner.hidden = !isLoading;
      submitLabel.textContent = isLoading ? 'Slanje…' : 'Rezerviši artikal';
    }

    function showForm() {
      formView.hidden = false;
      successView.hidden = true;
      dialog.setAttribute('aria-labelledby', 'GigaReservationTitle');
      dialog.setAttribute('aria-describedby', 'GigaReservationDescription');
    }

    function showSuccess() {
      formView.hidden = true;
      successView.hidden = false;
      dialog.setAttribute('aria-labelledby', 'GigaReservationSuccessTitle');
      dialog.removeAttribute('aria-describedby');
      successTitle.focus();
    }

    function closeModal() {
      requestToken += 1;
      setLoading(false);
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = previousOverflow;
      document.body.classList.remove('giga-reservation-open');
      showForm();
      const returnFocus = opener;
      opener = null;
      if (returnFocus && typeof returnFocus.focus === 'function') {
        returnFocus.focus();
      }
    }

    function openModal(button) {
      requestToken += 1;
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      opener = button;
      const sku = (button.getAttribute('data-reservation-sku') || '').trim();
      const title = button.getAttribute('data-reservation-title') || '';
      const image = button.getAttribute('data-reservation-image') || '';

      root.dataset.sku = sku;
      productTitle.textContent = title;
      if (image) {
        productImage.src = image;
        productImage.alt = title;
        productImage.hidden = false;
      } else {
        productImage.removeAttribute('src');
        productImage.alt = '';
        productImage.hidden = true;
      }

      showForm();
      setLoading(false);
      setFieldInvalid(nameInput, false);
      setFieldInvalid(phoneInput, false);
      setFieldInvalid(emailInput, false);
      setError(sku ? '' : MESSAGES.sku);

      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('giga-reservation-open');
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');

      window.setTimeout(function () {
        if (sku) nameInput.focus();
        else root.querySelector('.giga-reservation__close').focus();
      }, 0);
    }

    function validate() {
      const name = nameInput.value.trim();
      const phone = phoneInput.value.trim();
      const email = emailInput.value.trim();
      const sku = (root.dataset.sku || '').trim();
      const nameMissing = name.length === 0;
      const phoneMissing = !isAcceptablePhone(phone);
      const emailMissing = email.length === 0;

      setFieldInvalid(nameInput, nameMissing);
      setFieldInvalid(phoneInput, phoneMissing);
      setFieldInvalid(emailInput, emailMissing || (email.length > 0 && !isValidEmail(email)));

      if (nameMissing || phoneMissing || emailMissing) {
        setError(MESSAGES.required);
        return null;
      }
      if (!isValidEmail(email)) {
        setError(MESSAGES.email);
        return null;
      }
      if (!sku) {
        setError(MESSAGES.sku);
        return null;
      }

      setError('');
      return {
        customer_name: name,
        customer_phone: phone,
        customer_email: email,
        sku: sku,
      };
    }

    document.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('[data-giga-reservation-open]');
        if (!button) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        openModal(button);
      },
      true
    );

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-giga-reservation-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (root.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }

      if (event.key !== 'Tab') return;
      const items = focusableElements();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    [nameInput, phoneInput, emailInput].forEach(function (input) {
      input.addEventListener('input', function () {
        setFieldInvalid(input, false);
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitting) return;

      const payload = validate();
      if (!payload) return;

      const token = requestToken + 1;
      requestToken = token;
      setLoading(true);

      fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response
            .json()
            .catch(function () {
              return null;
            })
            .then(function (data) {
              return { ok: response.ok, data: data };
            });
        })
        .then(function (result) {
          if (token !== requestToken || root.hidden) return;
          if (!result.ok || !result.data || result.data.success !== true) {
            setError(MESSAGES.server);
            setLoading(false);
            return;
          }
          setLoading(false);
          showSuccess();
          form.reset();
          closeTimer = window.setTimeout(closeModal, SUCCESS_CLOSE_MS);
        })
        .catch(function () {
          if (token !== requestToken || root.hidden) return;
          setError(MESSAGES.network);
          setLoading(false);
        });
    });
  });
})();
